import { required, minLength } from 'vuelidate/lib/validators'

export default {
  name: { required, minLength: minLength(1) }
}



// WEBPACK FOOTER //
// ./src/validation/ExterneOrganisation.js